import { SmartCardRow } from "./schemas";

function compareSmartCardsBySortKey(a: SmartCardRow, b: SmartCardRow): number {
  const sortKeyA = a.sort_key;
  const sortKeyB = b.sort_key;

  if (sortKeyA == null && sortKeyB != null) return 1;
  if (sortKeyA != null && sortKeyB == null) return -1;

  if (sortKeyA != null && sortKeyB != null) {
    if (sortKeyA < sortKeyB) return -1;
    if (sortKeyA > sortKeyB) return 1;
  }

  const createdAtA = a.created_at;
  const createdAtB = b.created_at;
  if (createdAtA == null && createdAtB != null) return 1;
  if (createdAtA != null && createdAtB == null) return -1;
  if (createdAtA != null && createdAtB != null) {
    if (createdAtA < createdAtB) return -1;
    if (createdAtA > createdAtB) return 1;
  }

  if (a.id < b.id) return -1;
  if (a.id > b.id) return 1;
  return 0;
}

export function sortSmartCards(cards: SmartCardRow[]): SmartCardRow[] {
  return [...cards].sort(compareSmartCardsBySortKey);
}
